import React, { Fragment, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import {
  Button,
  Input,
  SVGIcon,
} from '@pearsontechnology/aero-components';

import { ModalContent, ModalActions } from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import workspaceService from 'services/WorkspaceService';
import { getIcon, getColor } from 'Workspace/helpers';

import messages from './messages';
import {
  CoursewareList as ListWrapper,
  CoursewareListItem as ListItem,
} from './styles';

function ProjectSelector({
  onDismiss,
  onNext,
  projectService,
  theme,
}) {
  const [workspaceId, setWorkspaceId] = useState(null);
  const [projectList, setProjectList] = useState([]);
  const [projectFilterValue, setProjectFilterValue] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);

  useEffect(() => {
    const getSelectedWorkspaceId = async () => {
      const id = await workspaceService.getSelectedWorkspaceId();
      setWorkspaceId(id);
    };
    getSelectedWorkspaceId();
    getProjectList(workspaceId);
  }, [getProjectList, workspaceId]);

  const getProjectList = useCallback(async () => {
    if (!workspaceId) return;
    const list = await projectService.getProjectsList(workspaceId);
    setProjectList(list);
  }, [projectService, workspaceId]);

  const filterList = (value) => {
    if (!value) {
      return projectList;
    }

    const searchValue = value.toLowerCase();
    return projectList.filter((project) =>
      project.name.toLowerCase().indexOf(searchValue) >= 0
    );
  };

  const handleSearchInput = (event) => {
    setProjectFilterValue(event.target.value);
  };

  const selectProject = (project) => () => {
    setSelectedProject(project);
    setIsNextButtonDisabled(false);
  };

  const filteredProjectList = filterList(projectFilterValue);

  return (
    <Fragment>
      <ModalContent unpadBottom>
        <Input.Search
          width={'100%'}
          onChange={handleSearchInput}
          placeholder={intl.formatMessage(messages.searchProject)}
          label={intl.formatMessage(messages.searchProject)}
        />
      </ModalContent>
      <ListWrapper>
        {filteredProjectList.map((project) => (
          <ListItem
            key={project.id}
            onClick={selectProject(project)}
            selected={selectedProject && selectedProject.name === project.name}
          >
            <SVGIcon
              icon={getIcon('project')}
              viewBox="0 0 24 24"
              fill={getColor('project', theme)}
              width={{ width: '24px', height: '24px' }}
            />
            {project.name}
          </ListItem>
        ))}
      </ListWrapper>
      <ModalActions scrim>
        <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
        <Button
          primary
          disabled={isNextButtonDisabled}
          onClick={() => onNext(selectedProject.id)}
        >
          {intl.formatMessage(messages.nextButton)}
        </Button>
      </ModalActions>
    </Fragment>
  );
}

ProjectSelector.propTypes = {
  onDismiss: PropTypes.func,
  onNext: PropTypes.func,
  projectService: PropTypes.object,
  theme: PropTypes.object,
};

export default withTheme(ProjectSelector);
